import { render } from "./SmartTherapeuticDevice.vue?vue&type=template&id=7b81de6a&scoped=true"
import script from "./SmartTherapeuticDevice.vue?vue&type=script&lang=js"
export * from "./SmartTherapeuticDevice.vue?vue&type=script&lang=js"

import "./SmartTherapeuticDevice.vue?vue&type=style&index=0&id=7b81de6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b81de6a"]])

export default __exports__